module.exports = __webpack_public_path__ + "assets/images/10B-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10B-route-sheet.png
// module id = 1275
// module chunks = 1